import React, {useEffect, useState} from 'react';
import {Platform, Text, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import Header from '../../components/elements/Header';
import VerifyCode from '../../components/modules/VerifyCode';
import makeStyles from './styles';
import {useThemedStyles} from '../../theme';
import {getCountryCode} from '../../utils/HelperMethods';
import UI from './ui';
import CommonStyles from '../../utils/CommonStyles';
import Button from '../../components/elements/Button';
import Popup from '../../components/elements/Popup';
import {getUserProfileData} from '../../utils/GeneralStorage';
import {tID} from '../../utils/TestIdHelper';
import {SEND_OTP_TYPES} from '../../utils/Constants';
import { CloseIcon } from '../../utils/SvgIcons';

export const SuccessPopup = ({showSuccesModal, onPressFinish = () => {}}) => {
  return (
    <Popup
      testID={tID('ChangePhoneNumberVerification-Popup-Success')}
      visible={showSuccesModal}
      textAlign="center"
      title="Success!"
      description={'Phone number successfully changed.'}>
      <Button
        testID={tID('ChangePhoneNumberVerification-Button-Continue')}
        style={CommonStyles.full_flex}
        onPress={onPressFinish}
        title={'Continue'}
      />
    </Popup>
  );
};

const ChangePhoneNumberVerification = ({
  navigation,
  route,
  openPopup,
  onClosePopup = () => {},
}) => {
  const styles = useThemedStyles(makeStyles);
  const phoneNo = route.params.phoneNo;
  const [showSuccesModal, setShowSuccesModal] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    async function fetchProfileData() {
      const profileData = await getUserProfileData();
      setEmail(profileData?.email);
    }
    if (Platform.OS === 'web') fetchProfileData();
  }, []);

  const onPressFinish = () => {
    onClosePopup();
    setShowSuccesModal(false);
  };

  return (
    <UI
      openPopup={openPopup}
      showSuccesModal={showSuccesModal}
      onPressFinish={onPressFinish}>
      <SafeAreaView
        testID={tID('ChangePhoneNumberVerification-SafeAreaView-Main')}
        style={[
          styles.screenBackground,
          Platform.OS === 'web' ? styles.webcontainer : CommonStyles.full_flex,
        ]}>
        <View
          testID={tID('ChangePhoneNumberVerification-View-HeaderContainer')}
          style={styles.headerView}>
          <Header
            title={Platform.OS === 'web' ? 'Phone Verification' : 'Verify'}
            leftImage={<CloseIcon/>}
            onPressLeftIcon={
              Platform.OS === 'web' ? onClosePopup : navigation.goBack
            }
          />
        </View>
        <View style={styles.container}>
          {Platform.OS !== 'web' && (
            <Text
              testID={tID('ChangePhoneNumberVerification-Text-Title')}
              style={styles.title}>
              Phone Verification
            </Text>
          )}
          <Text style={styles.subtitle}>
            Please enter the 6-digit code sent to you at
            <Text
              testID={tID('ChangePhoneNumberVerification-Text-PhoneNumber')}
              style={styles.boldFont}>
              {' ' + getCountryCode() + ' ' + phoneNo}
            </Text>
          </Text>
        </View>

        <View
          style={[
            styles.subcontainer,
            Platform.OS === 'web' ? styles.webSubContainer : styles.topBorder24,
          ]}>
          <VerifyCode
            phoneNo={phoneNo}
            type={SEND_OTP_TYPES.changePhone}
            nextScreen="EditProfile"
            needsLogin={false}
            onVerificationSuccess={() => setShowSuccesModal(true)}
            authCredentials={{username: email}}
          />
        </View>
      </SafeAreaView>
    </UI>
  );
};

export default ChangePhoneNumberVerification;
